import React, { Component } from 'react';
import { Toggle } from '@getgrover/ui';

import { Container, TextTypography } from './styles';

export class ToggleInput extends Component {
    handleChange = () => {
        const { onChange, value, disabled } = this.props;

        if (!disabled) {
            const checked = Boolean(value);
            onChange(!checked);
        }
    };

    render() {
        const { value, label, name, disabled, theme } = this.props;

        const checked = Boolean(value);

        return (
            <Container>
                <Toggle
                    disabled={disabled}
                    checked={checked}
                    id={name}
                    onChange={this.handleChange}
                    color={theme.colors.Color1}
                />
                <TextTypography tag="label" htmlFor={name}>
                    {label}
                </TextTypography>
            </Container>
        );
    }
}

ToggleInput.defaultProps = {
    name: '',
    label: '',
    value: false,
    checked: false,
    disabled: false,
    onChange: () => {},
};

export default ToggleInput;
